import {
  darkThemeStyles,
  JupiterTheme,
  MockHook,
} from '@jupiterone/jupiter-web-toolkit';
import {
  Button,
  CircularProgress,
  FormGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { MouseEventHandler } from 'react';
import useMfaSettingsLogic, {
  MfaSettingsComponentProps,
  Step,
} from './useMfaSettingsLogic';
import QRCode from 'qrcode.react';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    ...darkThemeStyles,
    textCenter: {
      margin: '0 auto',
      padding: '40px',
      height: '100%',
      width: '100%',
      textAlign: 'center',
    },
    qrSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    helpText: {
      color: theme.palette.common.white,
      padding: `${theme.spacing(2)}px 0px`,
    },
    textInputLabel: {
      color: theme.palette.navy[200],
    },
    button: {
      color: 'white',
      margin: 'auto',
    },
    checkbox: {
      color: 'white',
    },
    qrCode: {
      padding: '5px',
      backgroundColor: 'white',
    },
    center: {
      textAlign: 'center',
    },
  });
});

export const MfaSettingsComponent = ({
  loading,
  currentStep,
  mfaCode,
  qrCodeUri,
  handleDeleteMFADevice,
  handleCodeChange,
  handleVerifyMfaCode,
  handleGenerateQRCode,
}: MfaSettingsComponentProps) => {
  const classes = useStyles();
  if (loading) {
    return <CircularProgress />;
  }
  if (currentStep === Step.NO_DEVICE) {
    return (
      <SimpleButton
        onChangeHandler={handleGenerateQRCode}
        className={classes.button}
        buttonText={'Add MFA Device'}
      />
    );
  } else if (currentStep === Step.DELETE_MFA_DEVICE) {
    return (
      <SimpleButton
        onChangeHandler={handleDeleteMFADevice}
        className={classes.button}
        buttonText={'Delete MFA Device'}
      />
    );
  } else if (currentStep === Step.GENERATE_QR_CODE) {
    if (qrCodeUri) {
      return (
        <div className={classes.qrSection}>
          <Typography className={classes.helpText}>
            Scan this QR code in your MFA app and then enter the validation code
            below
          </Typography>
          <div className={classes.qrCode}>
            <QRCode value={qrCodeUri} />
          </div>
          <form className={classes.center}>
            <TextField
              id="code"
              label="Enter MFA Code"
              value={mfaCode}
              className={classes.textInput}
              InputLabelProps={{
                className: classes.textInputLabel,
              }}
              InputProps={{
                className: classes.textInput,
              }}
              margin="normal"
              fullWidth={true}
              onChange={handleCodeChange}
            />
            <SimpleButton
              onChangeHandler={handleVerifyMfaCode}
              className={classes.button}
              buttonText={'Verify MFA Code'}
            />
          </form>
        </div>
      );
    } else {
      return (
        <SimpleButton
          onChangeHandler={handleGenerateQRCode}
          className={classes.button}
          buttonText={'Generate QR Code'}
        />
      );
    }
  } else if (currentStep === Step.VERIFY_MFA_CODE) {
    return (
      <form>
        <FormGroup row>
          <TextField
            id="code"
            label="Enter MFA Code"
            value={mfaCode}
            className={classes.textInput}
            InputLabelProps={{
              className: classes.textInputLabel,
            }}
            InputProps={{
              className: classes.textInput,
            }}
            margin="normal"
            fullWidth={true}
            onChange={handleCodeChange}
          />
        </FormGroup>
        <SimpleButton
          onChangeHandler={handleVerifyMfaCode}
          className={classes.button}
          buttonText={'Verify MFA Code'}
        />
      </form>
    );
  }
  // Components must always return something
  return null;
};

const SimpleButton = ({
  onChangeHandler,
  className,
  buttonText,
}: {
  onChangeHandler: MouseEventHandler;
  className: string;
  buttonText: string;
}) => {
  return (
    <Button
      variant="contained"
      size="small"
      color="primary"
      className={className}
      onClick={onChangeHandler}
    >
      {buttonText}
    </Button>
  );
};
export default MockHook.withHookHoc(MfaSettingsComponent, useMfaSettingsLogic);
